import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import styles from './styles.css';

interface ILayoutProps {
  stretch?: boolean;
  children?: ReactNode;
}

export const Layout: FC<ILayoutProps> = ({ children, stretch }) => {
  return <div className={clsx(styles['container'], { [styles['stretch']]: stretch })}>{children}</div>;
};
